import React, { forwardRef } from 'react';
export const Input = forwardRef(({ id, hasError, className, ...props }, ref) => (React.createElement("input", { ...props, id: id, className: `cb-text-2 cb-input${hasError ? ' cb-input-error' : ''}${className ? ` ${className}` : ''}`, ref: ref })));
